<template>
  <img src="/icons/loader.png" class="loading" :class="`loading-${size}`" />
</template>

<script lang="ts" setup>
  const { size } = defineProps<{
    size?: 'sm' | 'md' | 'lg' | 'xl';
  }>();
</script>

<style>
:root {
  --mc-loading-icon-size: 64px;
  --mc-loading-icon-padding: 16px;
}
</style>

<style lang="scss" scoped>
.loading {
  width: var(--mc-loading-icon-size);
  height: var(--mc-loading-icon-size);
  padding: var(--mc-loading-icon-padding);
  animation: spin 2s linear infinite;
}
.loading-sm {
  width: 32px;
  height: 32px;
}
.loading-md {
  width: 48px;
  height: 48px;
}
.loading-lg {
  width: 64px;
  height: 64px;
}
.loading-xl {
  width: 128px;
  height: 128px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
